module.exports = __webpack_public_path__ + "img/SWP_Shield_04 (2).636b72cd.png";